import { useEffect, useState } from 'react';
import Title from '../../../componente/cadastro/titulo/index.jsx';
import Description from '../../../componente/cadastro/descricao/index.jsx';
import SearchField from '../../../componente/cadastro/busca/index.jsx';
import AddButton from '../../../componente/cadastro/botaoadd/index.jsx';
import AddButtonEmpresa from '../../../componente/cadastro/botaoadd/index.jsx';
import Table from '../../../componente/cadastro/tabela/index.jsx';
import TableEmpresa from '../../../componente/cadastro/tabela/index.jsx';
import Pagination from '../../../componente/cadastro/paginacao/index.jsx';
import Sidebar from "../../../componente/sidebar/index.jsx";
import "./style.css";
import api from "../../../services/api.js";
import { useAppContext } from "../../context/AppContext.jsx";
import { toast } from 'react-hot-toast';
import Modal from "react-modal";
import PopUp from "../../../componente/popup/index.jsx";
import PopUpEmpresa from "../../../componente/popup/index.jsx";
import { usePermissoes } from "../../../componente/permissoes";

Modal.setAppElement("#root");

const CadUsuario = () => {
    const { podeInserir, podeEditar, podeExcluir } = usePermissoes();

    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(50);
    const [data, setData] = useState([]);
    const [dataEmpresa, setDataEmpresa] = useState([]);
    const [empresa, setEmpresa] = useState([]);
    const [permissoes, setPermissoes] = useState([]);
    const [pagination, setPagination] = useState({
        total: 0,
        totalPages: 0
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showform, setshowform] = useState(false);
    const { accessKey, codassinante } = useAppContext(); // Acessa os dados do contexto          
    const [novo, setnovo] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenEmpresa, setIsOpenEmpresa] = useState(false);
    const columns = [
        { key: 'codusuario', title: 'Código' },
        { key: 'usuario', title: 'Usuário' },
    ];
    const columnsEmpresa = [
        { key: 'razaosocial', title: 'Razão Social' },
        { key: 'nomefantasia', title: 'Nome Fantasia' },
        { key: 'cnpj', title: 'CNPJ' },
        { key: 'cidade', title: 'Cidade' },
        { key: 'bairro', title: 'Bairro' },
    ];

    //campos
    const [codusuario, setCodUsuario] = useState(0);
    const [usuario, setUsuario] = useState("");
    const [senha, setSenha] = useState("");

    const [codusuarioempresa, setCodUsuarioEmpresa] = useState(0);
    const [codempresa, setCodEmpresa] = useState(0);

    const Permissao = [
        {
            "codusuarioperfil": 0,
            "rotina": "Cadastro de Empresa",
            "caminho": "/cad/empresa",
            "permissao_ver": "S",
            "permissao_inserir": "S",
            "permissao_editar": "S",
            "permissao_excluir": "S",
            "permissao_imprimir": "S"
        },
        {
            "codusuarioperfil": 0,
            "rotina": "Cadastro de Funcionario",
            "caminho": "/cad/funcionario",
            "permissao_ver": "S",
            "permissao_inserir": "S",
            "permissao_editar": "S",
            "permissao_excluir": "S",
            "permissao_imprimir": "S"
        },
        {
            "codusuarioperfil": 0,
            "rotina": "Cadastro de Usuario",
            "caminho": "/cad/usuario",
            "permissao_ver": "S",
            "permissao_inserir": "S",
            "permissao_editar": "S",
            "permissao_excluir": "S",
            "permissao_imprimir": "S"
        },
        {
            "codusuarioperfil": 0,
            "rotina": "Cadastro de Produto",
            "caminho": "/cad/produto",
            "permissao_ver": "S",
            "permissao_inserir": "S",
            "permissao_editar": "S",
            "permissao_excluir": "S",
            "permissao_imprimir": "S"
        },
        {
            "codusuarioperfil": 0,
            "rotina": "Cadastro de Cliente",
            "caminho": "/cad/cliente",
            "permissao_ver": "S",
            "permissao_inserir": "S",
            "permissao_editar": "S",
            "permissao_excluir": "S",
            "permissao_imprimir": "S"
        },
        {
            "codusuarioperfil": 0,
            "rotina": "Cadastro de Fornecedor",
            "caminho": "/cad/fornecedor",
            "permissao_ver": "S",
            "permissao_inserir": "S",
            "permissao_editar": "S",
            "permissao_excluir": "S",
            "permissao_imprimir": "S"
        },
        {
            "codusuarioperfil": 0,
            "rotina": "Cadastro de Categoria",
            "caminho": "/cad/categoria",
            "permissao_ver": "S",
            "permissao_inserir": "S",
            "permissao_editar": "S",
            "permissao_excluir": "S",
            "permissao_imprimir": "S"
        },
        {
            "codusuarioperfil": 0,
            "rotina": "Cadastro de Moeda",
            "caminho": "/cad/moeda",
            "permissao_ver": "S",
            "permissao_inserir": "S",
            "permissao_editar": "S",
            "permissao_excluir": "S",
            "permissao_imprimir": "S"
        },
        {
            "codusuarioperfil": 0,
            "rotina": "Cadastro de Caixa",
            "caminho": "/cad/caixa",
            "permissao_ver": "S",
            "permissao_inserir": "S",
            "permissao_editar": "S",
            "permissao_excluir": "S",
            "permissao_imprimir": "S"
        },
        {
            "codusuarioperfil": 0,
            "rotina": "Lançamento de Pedidos",
            "caminho": "/ope/pedido",
            "permissao_ver": "S",
            "permissao_inserir": "S",
            "permissao_editar": "S",
            "permissao_excluir": "S",
            "permissao_imprimir": "S"
        },
        {
            "codusuarioperfil": 0,
            "rotina": "Lançamento de Orçamento",
            "caminho": "/ope/orcamento",
            "permissao_ver": "S",
            "permissao_inserir": "S",
            "permissao_editar": "S",
            "permissao_excluir": "S",
            "permissao_imprimir": "S"
        },
        {
            "codusuarioperfil": 0,
            "rotina": "Contas a Pagar",
            "caminho": "/ope/contaspagar",
            "permissao_ver": "S",
            "permissao_inserir": "S",
            "permissao_editar": "S",
            "permissao_excluir": "S",
            "permissao_imprimir": "S"
        },
        {
            "codusuarioperfil": 0,
            "rotina": "Contas a Receber",
            "caminho": "/ope/contasreceber",
            "permissao_ver": "S",
            "permissao_inserir": "S",
            "permissao_editar": "S",
            "permissao_excluir": "S",
            "permissao_imprimir": "S"
        },
        {
            "codusuarioperfil": 0,
            "rotina": "Relação de Notas",
            "caminho": "/ope/relacaonota",
            "permissao_ver": "S",
            "permissao_inserir": "S",
            "permissao_editar": "S",
            "permissao_excluir": "S",
            "permissao_imprimir": "S"
        },
        {
            "codusuarioperfil": 0,
            "rotina": "Lançamento de Entrada de Produto",
            "caminho": "/ope/entradaprodutos",
            "permissao_ver": "S",
            "permissao_inserir": "S",
            "permissao_editar": "S",
            "permissao_excluir": "S",
            "permissao_imprimir": "S"
        },
        {
            "codusuarioperfil": 0,
            "rotina": "Estoque Por Empresa",
            "caminho": "/rel/estoqueporempresa",
            "permissao_ver": "S",
            "permissao_inserir": "S",
            "permissao_editar": "S",
            "permissao_excluir": "S",
            "permissao_imprimir": "S"
        },
        {
            "codusuarioperfil": 0,
            "rotina": "Relatório de Vendas",
            "caminho": "/rel/relpedido",
            "permissao_ver": "S",
            "permissao_inserir": "S",
            "permissao_editar": "S",
            "permissao_excluir": "S",
            "permissao_imprimir": "S"
        },
        {
            "codusuarioperfil": 0,
            "rotina": "Relatório de Recebimento Por Moeda",
            "caminho": "/rel/relrecebimentopormoeda",
            "permissao_ver": "S",
            "permissao_inserir": "S",
            "permissao_editar": "S",
            "permissao_excluir": "S",
            "permissao_imprimir": "S"
        }
    ];

    const handleOpen = (cad) => {
        setCodUsuario(cad.codusuario);
        setIsOpen(true);
    };

    const handleConfirma = () => {
        setIsOpen(false);
        handleDelete();
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleEmpresaOpen = (cad) => {
        setCodUsuarioEmpresa(cad.codusuarioempresa);
        setIsOpenEmpresa(true);
    };

    const handleEmpresaConfirma = () => {
        setIsOpenEmpresa(false);
        handleEmpresaDelete();
    };

    const handleEmpresaClose = () => {
        setIsOpenEmpresa(false);
    };

    const fetchData = async (searchTerm, page, limit) => {
        try {
            setLoading(true);
            setError(null);
            const response = await api.get("v1/cad/usuario", {
                params: {
                    busca: searchTerm,
                    page,
                    per_page: limit,
                    codassinante
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setData(response.data.data);
            setPagination({
                total: response.data.pagination.Total,
                totalPages: response.data.pagination.TotalPages
            });
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            fetchData(search, currentPage, perPage);
        }, 1000); // Aguarda 1 segundo após o usuário parar de digitar

        // Cleanup function para limpar o timeout anterior
        return () => clearTimeout(timeoutId);
    }, [search, currentPage, perPage]);

    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
        setCurrentPage(1); // Volta para primeira página ao mudar quantidade
    };

    const fetchDataEmpresa = async (codigo) => {
        try {
            setLoading(true);
            setError(null);
            const response = await api.get("v1/cad/usuario/usuarioempresa", {
                params: {
                    codusuario: codigo,
                    busca: ''
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setDataEmpresa(response.data);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    const fetchEmpresa = async (searchTerm, page, limit) => {
        try {
            setLoading(true);
            setError(null);
            const response = await api.get("v1/cad/empresa", {
                params: {
                    busca: searchTerm,
                    page,
                    per_page: limit,
                    codassinante
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setEmpresa(response.data.data);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = async (user) => {
        try {
            setLoading(true);
            setError(null);
            const response = await api.get("v1/cad/usuarioum", {
                params: {
                    codusuario: user.codusuario
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setshowform(true);
            setnovo(false);

            setCodUsuario(user.codusuario);
            setUsuario(response.data.usuario);
            setSenha(response.data.senha);

            setCodEmpresa(0);
            setCodUsuarioEmpresa(0);

            fetchEmpresa('', 1, 50);
            fetchDataEmpresa(user.codusuario);

            const perfilAPI = response.data.perfil || [];

            const perfilFinal = Permissao.map((itemDefault) => {
                const encontrado = perfilAPI.find(
                    (item) => item.rotina === itemDefault.rotina
                );

                if (encontrado) {
                    return {
                        ...itemDefault,
                        codusuarioperfil: encontrado.codusuarioperfil,
                        permissao_ver: encontrado.permissao_ver,
                        permissao_inserir: encontrado.permissao_inserir,
                        permissao_editar: encontrado.permissao_editar,
                        permissao_excluir: encontrado.permissao_excluir,
                        permissao_imprimir: encontrado.permissao_imprimir,
                    };
                }

                return itemDefault;
            });

            setPermissoes(perfilFinal);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        try {
            setLoading(true);
            setError(null);
            await api.delete("v1/cad/usuario", {
                params: {
                    codusuario,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            fetchData(search, currentPage, perPage);
            toast.success('Excluído com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    const handleEmpresaDelete = async () => {
        try {
            setLoading(true);
            setError(null);
            await api.delete("v1/cad/usuario/usuarioempresa", {
                params: {
                    codusuarioempresa,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            fetchDataEmpresa(codusuario);
            toast.success('Excluído com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    const handleAdd = () => {
        setshowform(true);
        setnovo(true);

        setCodUsuario(0);
        setUsuario('');
        setSenha('');

        setCodEmpresa(0);
        setCodUsuarioEmpresa(0);
        fetchEmpresa('', 1, 50);
        setDataEmpresa([]);

        setPermissoes(Permissao);
    };

    function Salvar() {
        novo ? Cadastrar() : Editar();
        setshowform(false);
    }

    async function Editar() {
        try {
            setLoading(true);
            setError(null);
            await api.put("v1/cad/usuario", {
                usuario,
                senha,
                codusuario,
                perfil: permissoes
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });
            fetchData(search, currentPage, perPage);
            toast.success('Edição feita com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    }

    async function Cadastrar() {
        try {
            setLoading(true);
            setError(null);
            await api.post("v1/cad/usuario", {
                usuario,
                senha,
                excluido: "N",
                codassinante,
                perfil: permissoes
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });
            fetchData(search, currentPage, perPage);
            toast.success('Registro Salvo com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    }

    async function CadastrarEmpresa() {
        if (novo) {
            try {
                setLoading(true);
                setError(null);
                const response = await api.post("v1/cad/usuario", {
                    usuario,
                    senha,
                    excluido: "N",
                    codassinante,
                },
                    {
                        headers: {
                            Authorization: `Bearer ${accessKey}`,
                        },

                    });

                setnovo(false);
                setCodUsuario(response.data.codusuario);

                try {
                    setLoading(true);
                    setError(null);
                    await api.post("v1/cad/usuario/usuarioempresa", {
                        codusuario: response.data.codusuario,
                        codempresa,
                    },
                        {
                            headers: {
                                Authorization: `Bearer ${accessKey}`,
                            },

                        });
                    fetchDataEmpresa(response.data.codusuario);
                    toast.success('Empresa vinculado com Sucesso!');
                } catch (error) {
                    console.error('Erro ao excluir dados:', error);
                    setError('Erro ao tentar excluir os dados. Tente novamente.');
                    toast.error('Ocorreu algum erro! ❌');
                } finally {
                    setLoading(false);
                }

                toast.success('Registro Salvo com Sucesso!');
            } catch (error) {
                console.error('Erro ao excluir dados:', error);
                setError('Erro ao tentar excluir os dados. Tente novamente.');
                toast.error('Ocorreu algum erro! ❌');
            } finally {
                setLoading(false);
            }
        } else {
            try {
                setLoading(true);
                setError(null);
                await api.post("v1/cad/usuario/usuarioempresa", {
                    codusuario,
                    codempresa,
                },
                    {
                        headers: {
                            Authorization: `Bearer ${accessKey}`,
                        },

                    });
                fetchDataEmpresa(codusuario);
                toast.success('Empresa vinculado com Sucesso!');
            } catch (error) {
                console.error('Erro ao excluir dados:', error);
                setError('Erro ao tentar excluir os dados. Tente novamente.');
                toast.error('Ocorreu algum erro! ❌');
            } finally {
                setLoading(false);
            }
        }
    }

    const handleCheckboxChange = (index, campo) => {
        const novaLista = [...permissoes];
        novaLista[index][campo] =
            novaLista[index][campo] === "S" ? "N" : "S";
        setPermissoes(novaLista);
    };

    return (
        <>
            <div className="app-container">
                <Sidebar />
                <main className="content-container">
                    <PopUp isOpen={isOpen} onClose={handleClose}>
                        <h2>Verificação</h2>
                        <p>Tem certeza que deseja excluir esse registro?</p>

                        <div className="row">
                            <div className="col-12 mt-3 d-flex justify-content-end">
                                <button
                                    className="btn btn-primary me-2"
                                    onClick={handleConfirma}
                                >
                                    Sim
                                </button>
                                <button className="btn btn-danger" onClick={handleClose}>
                                    Não
                                </button>
                            </div>
                        </div>
                    </PopUp>

                    <PopUpEmpresa isOpen={isOpenEmpresa} onClose={handleEmpresaClose}>
                        <h2>Verificação</h2>
                        <p>Tem certeza que deseja excluir esse registro?</p>

                        <div className="row">
                            <div className="col-12 mt-3 d-flex justify-content-end">
                                <button
                                    className="btn btn-primary me-2"
                                    onClick={handleEmpresaConfirma}
                                >
                                    Sim
                                </button>
                                <button className="btn btn-danger" onClick={handleEmpresaClose}>
                                    Não
                                </button>
                            </div>
                        </div>
                    </PopUpEmpresa>

                    <Modal
                        isOpen={showform}
                        onRequestClose={() => setshowform(false)}
                        overlayClassName="modal-overlay"
                        className="modal-content modal-xl"
                    >
                        <div className="container-fluid h-100">
                            <div className="modal-header">
                                {novo ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
                                <button type="button" className="btn-close" onClick={() => setshowform(false)}></button>
                            </div>

                            <div className="modal-body">
                                <form>
                                    <div className='row'>
                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="usuario"
                                                    value={usuario}
                                                    onChange={(e) => setUsuario(e.target.value)}
                                                />
                                                <label htmlFor="usuario">Usuário</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-4 col-lg-3 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="password"
                                                    name="senha"
                                                    id="senha"
                                                    value={senha}
                                                    onChange={(e) => setSenha(e.target.value)}
                                                />
                                                <label htmlFor="senha">Senha</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <hr />
                                        <h3 className='text-center'>Vincule as empresas ao acesso</h3>
                                        <hr />
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-10 col-lg-10 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <select
                                                    className="form-select"
                                                    id="empresa"
                                                    value={codempresa}
                                                    onChange={(e) => setCodEmpresa(e.target.value)}
                                                >
                                                    <option value="0">Escolha a empresa</option>
                                                    {empresa.map(function (emp) {
                                                        return (
                                                            <option
                                                                key={emp.codempresa}
                                                                value={emp.codempresa}
                                                            >
                                                                {emp.razaosocial} - {emp.cnpj}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                                <label htmlFor="empresa">Empresa</label>
                                            </div>
                                        </div>

                                        <div className="col-xl-2 col-lg-2 col-md-6 col-sm-12 text-center">
                                            <AddButtonEmpresa onClick={CadastrarEmpresa} text="Vincular Empresa" />
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <TableEmpresa
                                            columns={columnsEmpresa}
                                            data={dataEmpresa}
                                            onDelete={handleEmpresaOpen}
                                        />
                                    </div>

                                    <h4>Controle de Permissões</h4>
                                    <table className="table table-bordered table-hover mt-3">
                                        <thead className="table-dark">
                                            <tr>
                                                <th>Rotina</th>
                                                <th>Ver</th>
                                                <th>Inserir</th>
                                                <th>Editar</th>
                                                <th>Excluir</th>
                                                <th>Imprimir</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {permissoes.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.rotina}</td>

                                                    <td>
                                                        <input
                                                            type="checkbox"
                                                            checked={item.permissao_ver === "S"}
                                                            onChange={() => handleCheckboxChange(index, "permissao_ver")}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="checkbox"
                                                            checked={item.permissao_inserir === "S"}
                                                            onChange={() =>
                                                                handleCheckboxChange(index, "permissao_inserir")
                                                            }
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="checkbox"
                                                            checked={item.permissao_editar === "S"}
                                                            onChange={() =>
                                                                handleCheckboxChange(index, "permissao_editar")
                                                            }
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="checkbox"
                                                            checked={item.permissao_excluir === "S"}
                                                            onChange={() =>
                                                                handleCheckboxChange(index, "permissao_excluir")
                                                            }
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="checkbox"
                                                            checked={item.permissao_imprimir === "S"}
                                                            onChange={() =>
                                                                handleCheckboxChange(index, "permissao_imprimir")
                                                            }
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </form>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" onClick={() => setshowform(false)}>
                                    Cancelar
                                </button>
                                <button type="button" className="btn btn-success" onClick={Salvar}>
                                    Salvar
                                </button>

                            </div>
                        </div>
                    </Modal>

                    <div className="container-fluid py-4 d-flex flex-column" style={{ minHeight: '100vh' }}>
                        <Title text="Cadastro de Usuário" icon="user" />
                        <Description text="Cadastro dos usuários que vão acessar o sistema, e qual empresa terão acesso" />

                        <div className="row mb-3">
                            <div className="col-xl-10 col-lg-8 col-md-8 col-sm-12">
                                <SearchField
                                    value={search}
                                    onChange={setSearch}
                                    placeholder="Buscar usuários por: Código ou Usuário"
                                />
                            </div>
                            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12 text-center">
                                <AddButton onClick={handleAdd} text="Novo Usuário" disabled={!podeInserir("/cad/usuario")} />
                            </div>
                        </div>

                        {error && (
                            <div className="alert alert-danger" role="alert">
                                {error}
                            </div>
                        )}

                        <div className="flex-grow-1 d-flex flex-column">
                            {loading ? (
                                <div className="text-center py-4">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Carregando...</span>
                                    </div>
                                </div>
                            ) : (
                                <div className="table-wrapper flex-grow-1 d-flex flex-column">
                                    <Table
                                        columns={columns}
                                        data={data}
                                        onEdit={handleEdit}
                                        isEditDisabled={() => !podeEditar("/cad/usuario")}
                                        onDelete={handleOpen}
                                        isDeleteDisabled={() => !podeExcluir("/cad/usuario")}
                                    />
                                </div>
                            )}
                        </div>

                        <Pagination
                            currentPage={currentPage}
                            totalPages={pagination.totalPages}
                            onPageChange={setCurrentPage}
                            perPage={perPage}
                            onPerPageChange={handlePerPageChange}
                            total={pagination.total}
                        />
                    </div>
                </main>
            </div>
        </>
    );
};

export default CadUsuario;